import { Routes, Route, useLocation } from "react-router-dom";
import { DashboardLayout } from "../layouts/DashboardLayout";
import { Home } from "../pages/Home";
import { Login } from "../pages/Login";
import { NoMatch } from "../pages/NoMatch";
import { ProtectedLayout } from "../layouts/ProtectedLayout";
import { PublicLayout } from "../layouts/PublicLayout";
import { Signout } from "../pages/Signout";
import { Answer } from "../pages/Answer";
import { ListPage } from "../pages/ListPage";
import { DetailPage } from "../pages/DetailPage";
import { Proposal } from "../pages/Proposal";

import { SharedProposal } from "../pages/SharedProposal";
import { Contact } from "../pages/Contact";
import { Events } from "../pages/Events";
import { EventDetail } from "../pages/EventDetail";
import { Help } from "../pages/Help";
import { Calendar } from "../pages/Calendar";
import { SpeakerHolds } from "../pages/SpeakerHolds";
import { RequiredLoginLayout } from "../layouts/RequiredLoginLayout";
import { Document } from "../pages/Document";
import { FormContainer } from "../pages/FormContainer";
import { SpeakerSearch } from "../pages/SpeakerSearch";
import { ContactDetails } from "../pages/ContactDetails";
import { Dashboard } from "../pages/Dashboard";
// import { Dashboard } from "../pages/Dashboard/index copy";
import { useAuth } from "../hooks/useAuth";
import RequestToBookPage from "../pages/RequestToBookPage";
import MyFeeRequests from "../pages/MyFeeRequests";
import { useEffect, useState } from "react";
import { post } from "../api";

const Router = ({ application }) => {
    const { user, isAuthenticated, getUserDetailsNotAsync } = useAuth();
    const userData = getUserDetailsNotAsync();
    const [loaded, setLoaded] = useState(false);
    const [isProtectedLogin, setIsProtectedLogin] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const checkAuth = async () => {
            if (userData && userData["userType"] !== "user") {
                setLoaded(false);
                try {
                    await post("opportunity/isProposalOwner", { contactId: userData.contact.id }).then((result) => {
                        if (result.isSuccess && result.data) {
                            setIsProtectedLogin(true);
                        } else {
                            setIsProtectedLogin(false);
                        }
                    });
                } catch {
                    setIsProtectedLogin(false);
                } finally {
                    setLoaded(true);
                }
            } else {
                setLoaded(true);
                setIsProtectedLogin(false);
            }
        };
        checkAuth();
    }, [location.pathname]);

    if (!loaded) {
        return;
    }

    if (application === "preview") {
        return (
            <Routes>
                <Route element={<PublicLayout />}>
                    <Route path="/login" element={<Login application={application} />} />
                    <Route path="/answer" element={<Answer application={application} />}></Route>
                    <Route
                        path="/share/event-detail/:recordId"
                        element={
                            <DashboardLayout application={application} tab="my-events" publicPage={true}>
                                <EventDetail shared={true} />
                            </DashboardLayout>
                        }
                    />
                    <Route path="/signout" element={<Signout />} />
                    <Route path="*" element={<NoMatch />} />
                </Route>
                <Route element={<RequiredLoginLayout />}>
                    <Route
                        path="/preview/proposal/:recordId/:proposalId"
                        element={
                            <DashboardLayout
                                application={application}
                                tab="my-proposals"
                                publicPage={!isProtectedLogin}>
                                <Proposal application={application} />
                            </DashboardLayout>
                        }
                    />
                </Route>
            </Routes>
        );
    } else if (application === "speaker") {
        return (
            <Routes>
                <Route element={<PublicLayout />}>
                    <Route path="/login" element={<Login application={application} />} />
                    <Route path="/answer" element={<Answer application={application} />}></Route>
                    <Route
                        path="/share/event-detail/:recordId"
                        element={
                            <DashboardLayout application={application} tab="my-events" publicPage={true}>
                                <EventDetail shared={true} />
                            </DashboardLayout>
                        }
                    />
                    <Route path="/signout" element={<Signout />} />
                    <Route path="*" element={<NoMatch />} />
                </Route>

                <Route path="/" element={<ProtectedLayout />}>
                    <Route
                        path="/"
                        element={
                            <DashboardLayout application={application} tab="my-events">
                                <Events />
                            </DashboardLayout>
                        }></Route>
                    <Route
                        path="/event-detail/:recordId"
                        element={
                            <DashboardLayout application={application} tab="my-events">
                                <EventDetail />
                            </DashboardLayout>
                        }></Route>
                    <Route
                        path="/help"
                        element={
                            <DashboardLayout application={application} tab="help">
                                <Help application={application} />
                            </DashboardLayout>
                        }></Route>
                    <Route
                        path="/calendar"
                        element={
                            <DashboardLayout application={application} tab="calendar">
                                <Calendar />
                            </DashboardLayout>
                        }></Route>
                    <Route
                        path="/speaker-holds"
                        element={
                            <DashboardLayout application={application} tab="speaker-holds">
                                <SpeakerHolds />
                            </DashboardLayout>
                        }></Route>
                    <Route
                        path="/formContainer"
                        element={
                            <DashboardLayout application={application}>
                                <FormContainer />
                            </DashboardLayout>
                        }></Route>
                    <Route path="*" element={<NoMatch />}></Route>
                </Route>
                <Route element={<RequiredLoginLayout />}>
                    <Route
                        path="/shared/event-detail/:recordId"
                        element={
                            <DashboardLayout application={application} tab="my-events" publicPage={true}>
                                <EventDetail />
                            </DashboardLayout>
                        }
                    />
                    <Route
                        path="/shared/formContainer"
                        element={
                            <DashboardLayout application={application} tab="form" publicPage={true}>
                                <FormContainer />
                            </DashboardLayout>
                        }></Route>
                    <Route path="*" element={<NoMatch />} />
                </Route>
            </Routes>
        );
    }
    return (
        <Routes>
            <Route element={<PublicLayout />}>
                <Route path="/login" element={<Login />} />
                <Route path="/answer" element={<Answer />}></Route>
                <Route path="/signout" element={<Signout />} />

                <Route path="*" element={<NoMatch />} />
            </Route>

            <Route path="/" element={<ProtectedLayout />}>
                <Route
                    path="/"
                    element={
                        userData?.contact?.dashboardEnabled && isProtectedLogin ? (
                            <DashboardLayout
                                application={application}
                                tab="my-dashboard"
                                publicPage={!isProtectedLogin}>
                                <Dashboard />
                            </DashboardLayout>
                        ) : (
                            <DashboardLayout
                                application={application}
                                tab="my-proposals"
                                publicPage={!isProtectedLogin}>
                                <Home />
                            </DashboardLayout>
                        )
                    }></Route>
                <Route
                    path="/my-proposals"
                    element={
                        <DashboardLayout application={application} tab="my-proposals" publicPage={!isProtectedLogin}>
                            <Home />
                        </DashboardLayout>
                    }></Route>
                <Route
                    path="/proposal/:recordId"
                    element={
                        <DashboardLayout application={application} tab="my-proposals" publicPage={!isProtectedLogin}>
                            <Proposal application={application} />
                        </DashboardLayout>
                    }></Route>
                <Route
                    path="/proposal/:recordId/:proposalId"
                    element={
                        <DashboardLayout application={application} tab="my-proposals" publicPage={!isProtectedLogin}>
                            <Proposal application={application} />
                        </DashboardLayout>
                    }></Route>
                {isProtectedLogin && (
                    <Route
                        path="/pre-booking-questionnaire/:opportunityId/:recordId/:calendarEntryId"
                        element={
                            <DashboardLayout
                                application={application}
                                tab="my-proposals"
                                publicPage={!isProtectedLogin}>
                                <RequestToBookPage application={application} />
                            </DashboardLayout>
                        }></Route>
                )}
                {isProtectedLogin && (
                    <Route
                        path="/sharedProposal"
                        element={
                            <DashboardLayout application={application} publicPage={!isProtectedLogin}>
                                <SharedProposal />
                            </DashboardLayout>
                        }></Route>
                )}
                {isProtectedLogin && (
                    <Route
                        path="/contact"
                        element={
                            <DashboardLayout application={application} tab="contact" publicPage={!isProtectedLogin}>
                                <Contact />
                            </DashboardLayout>
                        }></Route>
                )}
                {isProtectedLogin && (!userData?.contact || userData?.contact?.eventsEnabled) && (
                    <Route
                        path="/events"
                        element={
                            <DashboardLayout application={application} tab="my-events" publicPage={!isProtectedLogin}>
                                <Events />
                            </DashboardLayout>
                        }></Route>
                )}
                {isProtectedLogin && (!userData?.contact || userData?.contact?.eventsEnabled) && (
                    <Route
                        path="/event-detail/:recordId"
                        element={
                            <DashboardLayout application={application} tab="my-events" publicPage={!isProtectedLogin}>
                                <EventDetail />
                            </DashboardLayout>
                        }></Route>
                )}
                {isProtectedLogin && (
                    <Route
                        path="/calendar"
                        element={
                            <DashboardLayout application={application} tab="calendar" publicPage={!isProtectedLogin}>
                                <Calendar />
                            </DashboardLayout>
                        }></Route>
                )}
                {isProtectedLogin && (
                    <Route
                        path="/help"
                        element={
                            <DashboardLayout application={application} tab="help" publicPage={!isProtectedLogin}>
                                <Help />
                            </DashboardLayout>
                        }></Route>
                )}
                {isProtectedLogin && (
                    <Route
                        path="/documents"
                        element={
                            <DashboardLayout application={application} tab="documents" publicPage={!isProtectedLogin}>
                                <Document />
                            </DashboardLayout>
                        }></Route>
                )}
                {isProtectedLogin && (
                    <Route
                        path="/formContainer"
                        element={
                            <DashboardLayout application={application} publicPage={!isProtectedLogin}>
                                <FormContainer />
                            </DashboardLayout>
                        }></Route>
                )}
                {isProtectedLogin && (!userData?.contact || userData?.contact?.speakerSearchEnabled) && (
                    <Route
                        path="/speaker-search"
                        element={
                            <DashboardLayout
                                application={application}
                                tab="speaker-search"
                                publicPage={!isProtectedLogin}>
                                <SpeakerSearch application={application} />
                            </DashboardLayout>
                        }></Route>
                )}

                {isProtectedLogin && (
                    <Route
                        path="/my-fee-requests"
                        element={
                            <DashboardLayout
                                application={application}
                                tab="my-fee-requests"
                                publicPage={!isProtectedLogin}>
                                <MyFeeRequests />
                            </DashboardLayout>
                        }></Route>
                )}
                <Route path="*" element={<NoMatch />} />
            </Route>

            <Route element={<RequiredLoginLayout />}>
                <Route
                    path="/preview/proposal/:recordId/:proposalId"
                    element={
                        <DashboardLayout application={application} tab="my-proposals" publicPage={!isProtectedLogin}>
                            <Proposal application={application} />
                        </DashboardLayout>
                    }
                />
                <Route
                    path="/shared/proposal/:recordId/:proposalId"
                    element={
                        <DashboardLayout application={application} tab="my-proposals" publicPage={!isProtectedLogin}>
                            <Proposal
                                shared={userData?.userType === "public" ? true : false}
                                application={application}
                            />
                        </DashboardLayout>
                    }
                />
                <Route
                    path="/shared/proposal/:recordId"
                    element={
                        <DashboardLayout application={application} tab="my-proposals" publicPage={!isProtectedLogin}>
                            <Proposal
                                shared={userData?.userType === "public" ? true : false}
                                application={application}
                            />
                        </DashboardLayout>
                    }
                />
                <Route
                    path="/shared/event-detail/:recordId"
                    element={
                        <DashboardLayout application={application} tab="my-events" publicPage={!isProtectedLogin}>
                            <EventDetail shared={true} application={application} />
                        </DashboardLayout>
                    }
                />
                <Route
                    path="/shared/formContainer"
                    element={
                        <DashboardLayout application={application} tab="form" publicPage={!isProtectedLogin}>
                            <FormContainer />
                        </DashboardLayout>
                    }></Route>
                <Route path="/contact-details/:recordId/:proposalId" element={<ContactDetails />}></Route>
                <Route path="/contact-details/:recordId" element={<ContactDetails />}></Route>
                <Route
                    path="/share/proposal/:recordId"
                    element={
                        <DashboardLayout application={application} tab="my-proposals" publicPage={!isProtectedLogin}>
                            <Proposal shared={true} application={application} />
                        </DashboardLayout>
                    }
                />
                <Route
                    path="/share/proposal/:recordId/:proposalId"
                    element={
                        <DashboardLayout application={application} tab="my-proposals" publicPage={!isProtectedLogin}>
                            <Proposal shared={true} application={application} />
                        </DashboardLayout>
                    }
                />
                <Route
                    path="/share/event-detail/:recordId"
                    element={
                        <DashboardLayout application={application} tab="my-events" publicPage={!isProtectedLogin}>
                            <EventDetail shared={true} application={application} />
                        </DashboardLayout>
                    }
                />
                <Route path="*" element={<NoMatch />} />
            </Route>
        </Routes>
    );
};

export { Router };
